import styled from 'styled-components';

export const StyledForm = styled.form`
  padding: 20px;
  max-height: calc(100vh - 177px);
  overflow: auto;

  label {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
  }

  > *:not(:last-child) {
    margin-bottom: 20px;
  }

  .post-form-content {
    display: flex;
    height: calc(100vh - 217px);
  }

  .post-form-left {
    flex: 1;
  }

  .post-form-right {
    width: 40%;
    max-width: 400px;
    min-width: 300px;
    margin: 0px 0px 10px 15px;
    padding-right: 8px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .crop-image-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .post-form-save-btn {
    &.ant-btn {
      background-color: rgb(58, 187, 167);
      border-color: rgb(58, 187, 167);
      color: #fff;
      font-weight: 500;
      letter-spacing: 0.3px;
      transition: background-color 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease,
        transform 0.15s ease;
    }

    &.ant-btn:hover,
    &.ant-btn:focus {
      background-color: rgb(48, 165, 147);
      border-color: rgb(48, 165, 147);
      color: #fff;
      box-shadow: 0 6px 14px rgba(58, 187, 167, 0.35);
      transform: translateY(-1px);
    }

    &.ant-btn:active {
      background-color: rgb(40, 145, 129);
      border-color: rgb(40, 145, 129);
      transform: translateY(0);
      box-shadow: 0 2px 6px rgba(58, 187, 167, 0.3);
    }

    &.ant-btn[disabled],
    &.ant-btn[disabled]:hover,
    &.ant-btn.ant-btn-loading {
      background-color: rgb(58, 187, 167);
      border-color: rgb(58, 187, 167);
      color: #fff;
      opacity: 0.65;
      transform: none;
      box-shadow: none;
    }

    .ant-btn-loading-icon .anticon {
      color: #fff;
    }
  }

  .crop-image-content {
    align-items: center;
    background: white;
    padding: 25px 35px;
    border-radius: 3px;
    width: 100%;
    height: 100%;
    max-width: 1200px;
    max-height: calc(100vh - 85px);
  }
`;
